import {
    DateValue,
    TagsValue
} from "@comp/index.js";
import { proposeFormTags, reviseForm, updateFormRevision, viewFormRevision } from "./actions";
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";

export default {
    "label": "Revisions",
    "key": "Revisions",
    "local": true,
    "headers": [{
        "headerName": "Revision",
        "field": "Revision",
        "sort": "desc"
    }, {
        "headerName": "Date",
        "field": "Date",
        "filter": "agDateColumnFilter",
        "cellRenderer": DateValue
    }, {
        "headerName": "Reason",
        "field": "Reason"
    }, {
        "headerName": "Template Tags",
        "field": "Tags",
        "cellRenderer": TagsValue,
        "autoHeight": true,
        "wrapText": true
    }],
    "rowActions": [{
        "label": "Update Revision",
        "action": updateFormRevision
    }, {
        "label": "Propose Tags",
        "action": proposeFormTags,
        show({ rowItem, store }) {
            // if (appConfig.appPrefix !== "test") {
            //     return [false, "Proposed template tags are only available in the test tenant"];
            // }

            const user = store?.state?.user;
            
            // Check if user has permission
            if (user?.Security?.Database?.Read !== true) {
                return [false, "Cannot propose tags without Database.Read permission"];
            }
            
            // Check if there's a .docx source file (GeneratableFile or File)
            const hasGeneratableFile = rowItem.GeneratableFile && 
                                      typeof rowItem.GeneratableFile === 'string' && 
                                      rowItem.GeneratableFile.toLowerCase().endsWith('.docx');
            const hasFile = rowItem.File && 
                           typeof rowItem.File === 'string' && 
                           rowItem.File.toLowerCase().endsWith('.docx');
            
            if (!hasGeneratableFile && !hasFile) {
                return [false, "No .docx template file found for this revision"];
            }
            
            return [true, ""];
        }
    }, {
        "label": "Download Form Template",
        async action({ pageItem, rowItem, db }) {
            let rev = pageItem.Revisions[pageItem.RevisionID];
            let url = await db.download(`Database/DocumentTypes/${pageItem.ID}/Revisions/${pageItem.RevisionID}/${rev.File.split("/").pop()}`);
            window.open(url, "__blank");
        },
        show({ rowItem, pageItem }) {
            return [rowItem.ID === pageItem.RevisionID, "You can only download the latest revision"]
        }
    }, {
        "label": "Download MFAR",
        async action({ db, rowItem, pageItem, store }) {
            if (!store.state["Database/MFARQuestions"]) {
                await db.store("Database/MFARQuestions", store);
            }
            if (!rowItem.MFAR) {
                return;
            };
            if (typeof rowItem.MFAR === "string") {
                let url = await db.download(`Database/Handbooks/${pageItem.ID}/Revisions/${rowItem.ID}/${rowItem.MFAR}`);
                window.open(url, "__blank");
            } else if (typeof rowItem.MFAR === "object") {

                const mfarURL = await db.download("Database/DocumentTypes/mfar_test.docx");

                let fileBinary = await new Promise((resolve, reject) => {
                    PizZipUtils.getBinaryContent(mfarURL, (err, content) => {
                        if (err) reject(err);
                        resolve(content);
                    });
                });

                let zip = new PizZip(fileBinary);

                const doc = new Docxtemplater(zip);

                doc.setData({
                    title: pageItem.Name,
                    number: pageItem.Number || pageItem.Name,
                    revision: rowItem.Revision,
                    date: rowItem.Date,
                    reason: rowItem.Reason,
                    questions:
                        Object.entries(rowItem.MFAR).map(([key, value]) => {
                            return {
                                question: store.state["Database/MFARQuestions"][key].Question,
                                ans: value
                            };
                        })
                });

                doc.render();

                const out = doc.getZip().generate({
                    type: "blob",
                    mimeType:
                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                });
                // Output the document using Data-URI
                saveAs(out, "mfar.docx");
            }
        },
        show({ rowItem }) {
            return [!!rowItem.MFAR, "No MFAR found"];
        }
    }, {
        "label": "View Revision Details",
        "action": viewFormRevision,
        show({ rowItem }) {
            return [!!rowItem.MFAR, "No MFAR found"];
        }
    }],
    "actions": [
        {
            "label": "Revise Form",
            "action": reviseForm
        },
        {
            "label": "Download Latest",
            async action({ db, pageItem }) {
                let rev = pageItem.Revisions[pageItem.RevisionID];
                let url = await db.download(`Database/DocumentTypes/${pageItem.ID}/Revisions/${pageItem.RevisionID}/${rev.File}`);
                window.open(url, "__blank");
            }
        }
    ]
};
